import React, { useEffect, useRef, useState } from 'react';
import $ from 'jquery';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import './Responsive.css';
import Aside from './components/layouts/aside/Aside';
import Header from './components/layouts/header/Header';
import GrowthOffer from './components/growth/GrowthOffer';
import Switch from "./Switch";
import AuthLayout from './components/layouts/auth/AuthLayout';
import AuthRoutes from './modules/auth/routes/AuthRoutes';
import Icon from './components/base/Icon';
import {
    useGlobal, setUserId, useSocket,
    useEnvironment, openLoginModal, closeLoginModal, useHub,
    setChatList,
    getUserId,
    useOwnerUserId,
    updatePreferences,
    addOrUpdateJob,
    archiveJobs,
    updateStatuses,
    addOrUpdateChat,
    removeChat,
    addOrUpdateAnnouncement,
    dismissAnnouncement,
    forceClearCashe,
    loadJobsReportBody,
    deviceToken,
    signature,
    logout,
    useScreen,
    removeJob,
    addOrUpdateClaimedExt,
    removeClaimedExt,
    addOrUpdateLiveCall,
    endLiveCall,
    useDatabase,
    setOwnerUserId,
    setQuickReplies,
    addOrUpdateLatestCall,
    removeComponentState,
    hydrateMissedCallsSeenAt,
    isAccountLimited,
    setAccountLimited,
    onSubscriptionChanged,
    refetchLoadedData,
} from './core/Global';
import HUBResponse from './models/HUBResponse';
import { API_ROUTES } from './core/Constants';
import Div from './components/base/Div';
import { ToastContainer } from './components/base/Toast';
import FloatAudioPlayer from './components/float/FloatAudioPlayer';
import HangUp from './components/calls/HangUp';
import FloatCallSpy from './components/float/FloatCallSpy';
import NotificationsDrawer from './components/notification/NotificationsDrawer';
import ShareCalls from './components/calls/ShareCalls';
import PublicRoutes from './modules/public/routes/PublicRoutes';
import SignUpRoutes from './modules/signup/routes/SignUpRoutes';
import PublicLayout from './components/layouts/public/PublicLayout';
import SignUpLayout from './components/layouts/signup/SignUpLayout';
import Container from './components/base/Container';
import ModalLogout from './components/modals/ModalLogout';
import ModalLimited from './components/modals/ModalLimited';
import ModalAccountRestricted from './components/modals/ModalAccountRestricted';
import ModalCreateManager from './components/modals/ModalCreateManager';
import LineSetupWizard from './modules/voice/lines/views/LineSetupWizard';
import ModalSetTimezone from './components/modals/ModalSetTimezone';
import ChatDrawer from './components/drawers/ChatDrawer';
import CreateUserModal from './modules/accounts/components/CreateUserModal';
import ModalDefaultTechsRate from './components/modals/ModalDefaultTechsRate';
import NotificationCenter from './NotificationCenter';
import NotificationPermissionBanner from './components/notifications/NotificationPermissionBanner';
import Modal from './components/base/Modal';
import LoginPage from './modules/auth/views/LoginPage';
import CallsDrawer from './components/drawers/CallsDrawer';
import JobGlobalModals from './modules/crm/jobs/components/jobmodals/JobGlobalModals';
import MessageToJobFloat from './modules/chat/components/MessageToJobFloat';
import ChatGlobalModals from './modules/chat/components/ChatGlobalModals';
import ModalChangeEnvironment from './components/modals/ModalChangeEnvironment';
import { UserTypes } from './core/Enums';
import { HubConnectionState } from '@microsoft/signalr';
import AnnouncementDrawer from './modules/system/announcements/components/AnnouncementDrawer';
import { PWAInstallModal } from './components/pwa/PWAInstallModal';
import MobileNavBar from './components/layouts/header/MobileNavBar';
import MobileSearch, { MobileSearchRef } from './components/layouts/header/MobileSearch';
import ModulePageDrawer from './modules/mobile/views/ModulePageDrawer';
import { PermBanner } from './components/pwa/PermBanner';
import { ensurePushSubscribed } from './utilities/push';
import { usePWAStatus } from './hooks/usePWAStatus';
import SocketStatus from './components/socket/SocketStatus';
import PhoneDialer from './components/phone/PhoneDialer';
import FlexRow from './components/base/FlexRow';
import MauiEventListener from './components/maui/MauiEventListener';
import ModalLogin from './components/modals/ModalLogin';
import { isNativeApp } from './NativeAppBrdige';

let deviceId: string | null;

// The local cache only saves a round trip -- everything it holds came from the server and can
// come again. It must never be able to stop the app opening: a write that threw out of
// IndexedDB took the whole Init handler down with it, so `initilized` was never set, the
// "App Loading" screen stayed up, and nothing retried or said a word. Now a broken cache costs
// a warning in the console and one extra request, and the panel still opens.
const cacheWrite = async (work: Promise<any>): Promise<void> => {
    try { await work }
    catch (e) { console.warn("Local cache write failed; continuing without it.", e) }
}

const cacheRead = async <T,>(work: Promise<T>, fallback: T): Promise<T> => {
    try { return await work }
    catch (e) { console.warn("Local cache read failed; continuing without it.", e); return fallback }
}

function App() {


    const { isStandalone } = usePWAStatus();
    const [globalState, globalStateSet] = useGlobal();
    const mobileSearchRef = useRef<MobileSearchRef>(null);
    const [loaded, loadedSet] = useState<boolean>(false);
    const [authenticated, authenticatedSet] = useState<boolean>(false);
    const [Public, PublicSet] = useState<boolean>(false);
    const [SignUp, SignUpSet] = useState<boolean>(false);
    const [mainLayout, mainLayoutSet] = useState<boolean>(false);

    const hub = useHub();
    const db = useDatabase();
    const env = useEnvironment();
    const userId = getUserId();
    const ownerUserId = useOwnerUserId();
    const screen = useScreen();
    const socket = useSocket();


    const registerDevice = () => {
        hub.Post(API_ROUTES.RegisterDevice, {}, res => {
            deviceToken(res.data)
        })
    }

    useEffect(() => {
        registerDevice()
    }, [])

    // Toggle <html class="platform-native"> so global CSS can disable body scroll/rubber-band
    // when the page is running inside the native WebView host.
    useEffect(() => {
        const apply = () => {
            if (isNativeApp()) {
                document.documentElement.classList.add("platform-native");
            }
        };
        apply();
        // The native bridge may inject the flag slightly after the initial paint;
        // re-check shortly after mount to be safe.
        const t = window.setTimeout(apply, 500);
        return () => window.clearTimeout(t);
    }, []);

    const init = async () => {

        forceClearCashe()

        if (window.location.pathname.startsWith("/share/") || window.location.pathname.startsWith("/public/")) {
            $("body").attr("class", "bg-body");
            PublicSet(true);
            loadedSet(true);
            mainLayoutSet(false);
        }
        else if (window.location.pathname.startsWith("/auth/")) {
            $("body").attr("class", "bg-body");
            loadedSet(true);
            mainLayoutSet(false);
        }
        else if (window.location.pathname.startsWith("/join")) {
            $("body").attr("class", "bg-body");
            loadedSet(true);
            SignUpSet(true);
            mainLayoutSet(false);

            hub.Get(API_ROUTES.LoadApp, res => {
                if (res.data) {
                    globalStateSet({
                        countries: res.data.countries,
                        countriesAll: res.data.countriesAll,
                        prices: res.data.prices
                    })
                }
            });

        }
        else {

            var sign = signature();
            if (!sign) document.location.href = "/auth/login";

            mainLayoutSet(true);

            $("body").attr("class", "header-fixed header-tablet-and-mobile-fixed toolbar-enabled toolbar-fixed aside-enabled aside-fixed");

            const appLoaderSocketKey =
                socket.start(skt => {
                    skt.invoke("StartListenToAppLoader", globalState.deviceToken)
                        .then(() => {
                            skt.on("UpdateAppLoaderStatus", (percent: number, text: string) => {
                                initPercentSet(percent)
                                initTextSet(text)
                            })
                        })
                }, skt => {
                    skt.off("UpdateAppLoaderStatus")
                    skt.invoke("StopListenToAppLoader", globalState.deviceToken)
                })

            const versionings = await cacheRead(db.getAllCacheVersioning(), [])

            hub.Post(API_ROUTES.Init, {
                versioningItems: versionings
            }, async (res: HUBResponse<any>) => {

                if (res.success && res.data) {

                    await cacheWrite(db.updateCacheVersioningList(res.data.versionings))

                    if (res.data.jobStatuses) {
                        await cacheWrite(db.updateJobStatuses(res.data.jobStatuses))
                        await globalStateSet({
                            jobStatuses: res.data.jobStatuses
                        })
                    }
                    else {
                        const jobStatuses = await cacheRead(db.getJobStatuses(), [])
                        await globalStateSet({
                            jobStatuses: jobStatuses
                        })
                    }

                    if (res.data.jobTypes) {
                        await cacheWrite(db.updateJobTypes(res.data.jobTypes))
                        await globalStateSet({
                            jobTypes: res.data.jobTypes
                        })
                    }
                    else {
                        const jobTypes = await cacheRead(db.getJobTypes(), [])
                        await globalStateSet({
                            jobTypes: jobTypes
                        })
                    }

                    if (res.data.jobSources) {
                        await cacheWrite(db.updateJobSources(res.data.jobSources))
                        await globalStateSet({
                            jobSources: res.data.jobSources
                        })
                    }
                    else {
                        const jobSources = await cacheRead(db.getJobSrouces(), [])
                        await globalStateSet({
                            jobSources: jobSources
                        })
                    }

                    if (res.data.jobMetros) {
                        await cacheWrite(db.updateJobMetros(res.data.jobMetros))
                        await globalStateSet({
                            jobMetros: res.data.jobMetros
                        })
                    }
                    else {
                        const jobMetros = await cacheRead(db.getJobMetros(), [])
                        await globalStateSet({
                            jobMetros: jobMetros
                        })
                    }

                    if (res.data.tags) {
                        await cacheWrite(db.updateTags(res.data.tags))
                        await globalStateSet({
                            tags: res.data.tags
                        })
                    }
                    else {
                        const tags = await cacheRead(db.getTags(), [])
                        await globalStateSet({
                            tags: tags
                        })
                    }

                    if (res.data.flags) {
                        await cacheWrite(db.updateFlags(res.data.flags))
                        await globalStateSet({
                            flags: res.data.flags
                        })
                    }
                    else {
                        const flags = await cacheRead(db.getFlags(), [])
                        await globalStateSet({
                            flags: flags
                        })
                    }

                    if (res.data.technicians) {
                        await cacheWrite(db.updateTechs(res.data.technicians))
                        await globalStateSet({
                            techs: res.data.technicians
                        })
                    }
                    else {
                        const techs = await cacheRead(db.getTechs(), [])
                        await globalStateSet({
                            techs: techs
                        })
                    }

                    if (res.data.announcements) {
                        await cacheWrite(db.updateAnnouncements(res.data.announcements))
                        await globalStateSet({
                            announcements: res.data.announcements
                        })
                    }
                    else {
                        const announcements = await cacheRead(db.getAnnouncements(), [])
                        await globalStateSet({
                            announcements: announcements
                        })
                    }

                    if (res.data.quickReplies) {
                        await cacheWrite(db.updateQuickReplies(res.data.quickReplies))
                        await globalStateSet({
                            quickReplies: res.data.quickReplies
                        })
                    }
                    else {
                        const quickReplies = await cacheRead(db.getQuickReplies(), [])
                        await globalStateSet({
                            quickReplies: quickReplies
                        })
                    }

                    if (res.data.extensions) {
                        await cacheWrite(db.updateExtensions(res.data.extensions))
                        await globalStateSet({
                            extensions: res.data.extensions
                        })
                    }
                    else {
                        const extensions = await cacheRead(db.getExtensions(), [])
                        await globalStateSet({
                            extensions: extensions
                        })
                    }

                    if (res.data.queues) {
                        await cacheWrite(db.updateQueues(res.data.queues))
                        await globalStateSet({
                            queues: res.data.queues
                        })
                    }
                    else {
                        const queues = await cacheRead(db.getQueues(), [])
                        await globalStateSet({
                            queues: queues
                        })
                    }

                    if (res.data.phoneLines) {
                        await cacheWrite(db.updatePhoneLines(res.data.phoneLines))
                        await globalStateSet({
                            phoneLines: res.data.phoneLines
                        })
                    }
                    else {
                        const phoneLines = await cacheRead(db.getPhoneLines(), [])
                        await globalStateSet({
                            phoneLines: phoneLines
                        })
                    }

                    if (res.data.countries) {
                        await cacheWrite(db.updateCountries(res.data.countries))
                        await globalStateSet({
                            countries: res.data.countries
                        })
                    }
                    else {
                        const countries = await cacheRead(db.getCountries(), [])
                        await globalStateSet({
                            countries: countries
                        })
                    }

                    if (res.data.countriesAll) {
                        await cacheWrite(db.updateCountriesAll(res.data.countriesAll))
                        await globalStateSet({
                            countriesAll: res.data.countriesAll
                        })
                    }
                    else {
                        const countriesAll = await cacheRead(db.getCountriesAll(), [])
                        await globalStateSet({
                            countriesAll: countriesAll
                        })
                    }

                    await globalStateSet({

                        user: res.data.user,
                        ownerUser: res.data.ownerUser,
                        showTimezoneModal: (res.data.user.timeZoneId == null),
                        wallet: res.data.wallet,
                        roles: res.data.roles,
                        rolesDenied: res.data.rolesDenied,
                        accountPreferences: res.data.preferences,

                        unreadNotificationsCount: res.data.unreadCount,
                        unseenNotificationsCount: res.data.unseenCount,

                        prices: res.data.prices,
                        hasMaskedJobCalls: res.data.hasMaskedJobCalls,
                        hasCallRecording: res.data.hasCallRecording,
                        canUpgradePlan: res.data.canUpgradePlan,
                        planNotice: res.data.planNotice ?? undefined,
                        claimedExts: res.data.connectedExtensions,
                        latestCalls: res.data.latestCalls,
                        initilized: true
                    })

                    authenticatedSet(true);
                    setUserId(res.data.user.id);
                    hydrateMissedCallsSeenAt();
                    loadJobsReportBody(res.data.user);
                }
                else {
                    if (window.location.pathname === "" || window.location.pathname === "/") {
                        window.location.href = "/auth/login"
                    }
                    else openLoginModal();
                }
                socket.stop(appLoaderSocketKey);

            }, err => {
                socket.stop(appLoaderSocketKey);
                setTimeout(() => {
                    init();
                }, 3000);
            }, 60000);




        }

        setSizes();
        window.addEventListener("resize", setSizes);
        document.title = env.siteTitle;
    }

    const setSizes = () => {
        globalStateSet({ windowsWidth: window.getWindowWidth(), windowsHeight: window.getWindowHeight() })
    }


    useEffect(() => {
        if (globalState.deviceToken) init();
    }, [globalState.deviceToken])

    useEffect(() => {

        const onBack = () => {

            const items = globalState.componentStates ?? [];
            const last = items[items.length - 1];

            if (!last) {
                return;
            }

            last.close();
            removeComponentState(last.id);
        }


        window.addEventListener("rinvox-mauiapp-back", onBack);

        return () => {
            window.removeEventListener("rinvox-mauiapp-back", onBack);

        };

    }, [globalState.componentStates])

    useEffect(() => {


        const onNativeKeyboardStateChanged = (e: any) => {
            console.log("keyboard:", e.detail.state);

            if (e.detail.state === "show") {
                globalStateSet({ nativeKeyboardOpened: true })
            } else {
                globalStateSet({ nativeKeyboardOpened: false })
            }
        };

        window.addEventListener("rinvox-keyboard-state-changed", onNativeKeyboardStateChanged);

        return () => {
            window.removeEventListener("rinvox-keyboard-state-changed", onNativeKeyboardStateChanged);
        }

    }, [])

    useEffect(() => {
        if (globalState.componentStates?.length == 0) {
            setTimeout(() => {
                window.allowMauiAppClose = true;
            }, 500);
        }
        else {
            window.allowMauiAppClose = false;
        }
    }, [globalState.componentStates])

    // Jobs and chats are no longer fetched at bootstrap — each view loads its own slice on
    // mount (useEnsureJobs / useEnsureChats). refetchLoadedData is the socket reconnect
    // handler and only refreshes slices already in state.

    useEffect(() => {
        if (mainLayout && loaded) {
            window.KTMenuCreate();
            window.KTDrawerCreate();
            window.KTToggleCreate();

            setTimeout(() => {
                window.KTScrollCreate();
            }, 2000);
        }
    }, [mainLayout, loaded])


    useEffect(() => {

        // Clear the loader as soon as core data (Init) and the user are ready.
        // The live socket is NOT required to render the dashboard — it connects in
        // the background and (re)subscribes via socket.start below once Connected.
        // Previously this also required socketState == Connected, which meant a
        // socket that got stuck in "Connecting" on first launch left the app
        // spinning forever (only an app restart recovered it).
        if (globalState.initilized && globalState.user) {

            loadedSet(true);
            $("#div-root").removeClass("d-none");

            setTimeout(() => {
                window.KTIntroCreate();
            }, 1000);

            // The permission is deliberately NOT requested here. Chrome answers a request
            // that arrives on page load with its quiet UI (a small icon in the address bar
            // instead of a dialog) and leaves the promise pending, which then swallows the
            // request the user makes from the notification banner. Asking is that banner's
            // job now, off a real click.
            if ('Notification' in window && Notification.permission === 'granted') {
                ensurePushSubscribed(env.hubUrl, globalState.user!.id!).catch(console.error);
            }

            const socketKey = socket.start(
                skt => {

                    if (globalState.user?.userType == UserTypes.Technician) {

                        skt.invoke("StartListenToTechEvents", globalState.user.id)
                            .then(() => {

                                skt.on(`AddOrUpdateTechChat-${globalState.user?.id}`, data => {
                                    addOrUpdateChat(data);
                                })

                                skt.on(`AddOrUpdateTechJob-${globalState.user?.id}`, job => {
                                    addOrUpdateJob(job);
                                })

                                skt.on(`RemoveTechFromJob-${globalState.user?.id}`, job => {
                                    removeJob(job);
                                })

                            })


                    }
                    else {

                        skt.invoke("StartListenToEvents", ownerUserId)
                            .then(() => {

                                skt.on("AddOrUpdateJob", job => addOrUpdateJob(job))

                                skt.on("ArchiveJobs", ids => archiveJobs(ids))

                                skt.on("UpdateStatuses", data => updateStatuses(data))

                                skt.on("AddOrUpdateLiveCall", call => {
                                    addOrUpdateLiveCall(call)
                                })
                                skt.on("EndLiveCall", call => endLiveCall(call))

                                skt.on("AddOrUpdateChat", data => {
                                    addOrUpdateChat(data);
                                });

                                skt.on("RemoveChat", chatId => {
                                    removeChat(chatId);
                                });

                                skt.on("UpdateChatList", data => {
                                    setChatList(data);
                                });

                                skt.on("UpdateChatQuickReplies", data => {
                                    setQuickReplies(data);
                                });

                                skt.on("UpdateAccountPreferences", data => {
                                    if (data) updatePreferences(data);
                                });


                                skt.on("PublishAnnouncement", data => addOrUpdateAnnouncement(data));
                                skt.on("DismissAnnouncement", data => dismissAnnouncement(data));

                            });

                        if (globalState.user?.userType == UserTypes.Admin) {
                            skt.invoke("StartListenToAdminsEvents", ownerUserId)
                                .then(() => {

                                });
                        }

                        if (globalState.user?.userType == UserTypes.Agent) {
                            skt.invoke("StartListenToAgentsEvents", ownerUserId)
                                .then(() => {

                                });
                        }


                    }

                    skt.invoke("StartListenToPersonalEvents", userId)
                        .then(() => {

                            skt.on("ForceLogout", () => {
                                logout()
                                document.location.href = "/auth/login";
                            })

                            // A system admin moved into another account -- from another tab, or from
                            // the app. This tab is still on the one it loaded, showing that account's
                            // name over whatever the server now answers with, so it moves too: the
                            // cache goes, as it does for the tab that switched, and the page loads
                            // again in the new account. The tab that switched gets this as well; it
                            // is already on its way there.
                            skt.on("WorkspaceChanged", (newOwnerUserId?: string) => {
                                if (!newOwnerUserId || newOwnerUserId === ownerUserId) return
                                if (window.rinvoxWorkspaceReloading) return
                                window.rinvoxWorkspaceReloading = true

                                db.deleteDatabase().then(() => {
                                    setOwnerUserId(newOwnerUserId)
                                    document.location.reload()
                                })
                            })

                            skt.on("AccountLimited", () => {
                                setAccountLimited(true);
                            })

                            // One signal for the whole subscription page: plan, add-ons, numbers,
                            // usage and who is signed in.
                            skt.on("SubscriptionChanged", () => onSubscriptionChanged())

                            skt.on("AccountUnlimited", () => {
                                window.closeModal("modal-account-restricted");
                                setAccountLimited(false);
                            })

                            skt.on("AddOrUpdateClaimedExt", ext => addOrUpdateClaimedExt(ext))
                            skt.on("RemoveClaimedExt", extId => removeClaimedExt(extId))

                            skt.on("AddLatestCall", call => addOrUpdateLatestCall(call))

                        });

                }, skt => {

                    if (globalState.user?.userType == UserTypes.Technician) {
                        skt.invoke("StopListenToTechEvents", globalState.user.id)
                    }
                    else {
                        skt.invoke("StopListenToEvents", ownerUserId)
                        skt.invoke("StopListenToAdminsEvents", ownerUserId)
                        skt.invoke("StopListenToAgentsEvents", ownerUserId)
                    }

                    skt.invoke("StopListenToPersonalEvents", userId)

                }, refetchLoadedData);

            return () => {
                window.removeEventListener("resize", setSizes);
                socket.stop(socketKey);
            }
        }

    }, [globalState.initilized, globalState.socketState, globalState.user, ownerUserId])


    const [initPercent, initPercentSet] = useState(0)
    const [initText, initTextSet] = useState<string>("")


    useEffect(() => {
        window.allowMauiAppClose = true;
    }, [])


    return (
        <Router>

            <Div visible={!loaded && mainLayout} className='app-loader text-center'>
                <Icon icon='spinner-third' type='regular' spin />
                <h2>App Loading</h2>

                <FlexRow className="mt-10" column alignItems='center'>

                    <div style={{
                        width: 500,
                        maxWidth: "100%"
                    }}>
                        <div className="progress-custom bg-secondary">
                            <div className="progress-custom-bar bg-primary" style={{
                                width: `${initPercent}%`
                            }}></div>
                        </div>
                    </div>

                    <div className='text-center mt-2'
                        style={{
                            width: 500,
                            maxWidth: "100%"
                        }}>
                        {initText}
                    </div>

                </FlexRow>

            </Div>

            <Container visible={loaded && !authenticated && !Public && !SignUp}>
                <AuthLayout>
                    <AuthRoutes />
                </AuthLayout>
            </Container>

            <Container visible={loaded && SignUp}>
                <SignUpLayout>
                    <SignUpRoutes />
                </SignUpLayout>
            </Container>

            <Container visible={loaded && Public}>
                <PublicLayout>
                    <PublicRoutes />
                </PublicLayout>
            </Container>

            <Div visible={mainLayout} id="div-root" className="page d-flex flex-row flex-column-fluid d-none app-scroll">


                <Aside />
                <div className="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper"
                    style={{
                        paddingTop: screen.isMobile ? 60 : globalState.noToolbar ? 60 : globalState.fitToolbar ? 115 : 140
                    }}>
                    <Header />
                    {
                        // An upgrade offer, when the hub has one for this account.
                        loaded && globalState.user && <GrowthOffer />
                    }
                    {
                        loaded && globalState.user && <Switch />
                    }
                </div>
                {
                    globalState.selectedCallToPlay && <FloatAudioPlayer selectedCall={globalState.selectedCallToPlay} />
                }

                {
                    globalState.selectedCallToListen && <FloatCallSpy selectedCall={globalState.selectedCallToListen} />
                }


                <HangUp />

                {
                    globalState.selectedCallsToShare && <ShareCalls ids={globalState.selectedCallsToShare} />
                }


                <NotificationsDrawer authenticated={authenticated} />

                <ModalCreateManager />

                <ModalLogout />
                <ModalLimited />

                {
                    (globalState.user?.userType == UserTypes.Agent || globalState.user?.userType == UserTypes.Technician)
                    && isAccountLimited()
                    && <ModalAccountRestricted />
                }


                {globalState.showTimezoneModal && <ModalSetTimezone />}
                {globalState.showDefaultTechRateModal && <ModalDefaultTechsRate />}

                {globalState.showLineWizard && <LineSetupWizard />}

                {globalState.chatJob && <ChatDrawer job={globalState.chatJob} />}
                {globalState.callsDrawerJob && <CallsDrawer job={globalState.callsDrawerJob} />}

                {globalState.createUser && <CreateUserModal />}
                {globalState.createUserType && <CreateUserModal type={globalState.createUserType} />}


                <JobGlobalModals />
                <ChatGlobalModals />


                {globalState.messageToJob && <MessageToJobFloat msg={globalState.messageToJob} />}

                {globalState.updateEnvironemnt && <ModalChangeEnvironment />}


                {/* The tab bar belongs to the phone, not to the installed app: somebody opening
                    the console in Safari on their phone gets the same way around it as somebody
                    who added it to their home screen. It used to appear only once installed,
                    which left the browser with no navigation at all. */}
                {
                    screen.isMobile && !globalState.nativeKeyboardOpened &&
                    <>
                        <MobileNavBar onOpenSearch={() => mobileSearchRef.current?.open()} />
                    </>
                }

                {
                    screen.isMobile &&
                    <MobileSearch ref={mobileSearchRef} />
                }

                <ModulePageDrawer />

                {
                    !isNativeApp() && !screen.isMobile &&
                    !globalState.user?.isTech &&
                    !isStandalone &&
                    <PhoneDialer />
                }
            </Div>

            <ToastContainer />

            {/* A technician needs no owner id (they only listen to their own group), so
                a user without one must not keep the notification center unmounted. */}
            {globalState.user?.id
                && (globalState.user.ownerUserId || globalState.user.isTech)
                && <NotificationCenter userId={globalState.user.id}
                    ownerId={globalState.user.ownerUserId ?? ""}
                    isTech={!!globalState.user.isTech} />}

            {/* Signed in only — it must never sit over the login, sign up or public
                pages. Points at the browser's address bar, so desktop only. */}
            {loaded && authenticated && !Public && !SignUp
                && globalState.user?.id && !screen.isMobile && !isNativeApp()
                && <NotificationPermissionBanner />}

            {globalState.bottomComponents && <globalState.bottomComponents />}

            {globalState.loginModal && <ModalLogin />}

            {globalState.openAnnouncementsDrawer && <AnnouncementDrawer />}


            {/* <PWAInstallModal /> */}

            <SocketStatus />

            <MauiEventListener />

            {/* {
                isStandalone && <PermBanner />
            } */}

            <audio id="maincall" preload="auto" />
            <audio id="ringtone" preload="auto" />

        </Router>
    );
}

export default App;
